import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Survey from "./pages/Survey";
import { Terms, Privacy, Disclaimer } from "./pages/Legal";
import AppPage from "./pages/App";
import JoinWelcome from "./pages/JoinWelcome";
import GiveawayTerms from "./pages/GiveawayTerms";
import GroupJoin from "./pages/GroupJoin";
import { LangProvider } from "./lib/i18n";
import { captureReferralFromUrl } from "./lib/referral";

function App() {
  // Boot-time hook: parses `?ref=CODE` and `/join/CODE`, stores attribution,
  // and cleans the URL. Silent on failure — must never block rendering.
  React.useEffect(() => {
    captureReferralFromUrl();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/app" element={<AppPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/survey" element={<Survey />} />
            <Route path="/join/:code" element={<JoinWelcome />} />
            <Route path="/g/:code" element={<GroupJoin />} />
            <Route path="/giveaway-terms" element={<GiveawayTerms />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
